class Falecom {

	buttons = false
	target = false
	closeButton = false
	handleOut = null

	constructor() {

		this.buttons = document.querySelectorAll('button.fale-conosco,a[href="#fale-conosco"]')
		this.target = document.querySelector('.floater-falecom')

		if (this.target && this.buttons.length) {

			this.handleOut = this.clickOut.bind(this)

			for (const button of this.buttons) {

				button.addEventListener('click', (event) => {
					event.preventDefault()
					this.open()
				})

			}

			// Close button
			this.closeButton = this.target.querySelector('button.close')
			this.closeButton.addEventListener('click', (event) => {
				event.preventDefault()
				this.close()
			})

			// Bind finished
			const form = document.querySelector('#falecom')
			form.addEventListener('finished', () => {
				this.close()
			})

		}

	}

	clickOut(event) {
		if (
			!Piki.hasParent(event.target, 'floater-falecom')
			&&
			!event.target.classList.contains('floater-falecom')
			&&
			!Piki.hasParent(event.target, 'fale-conosco')
			&&
			!event.target.classList.contains('fale-conosco')
		) {
			this.close()
		}
	}

	open() {

		this.target.classList.add('opened')
		window.addEventListener('click', this.handleOut)

		if (window.innerHeight === this.target.offsetHeight) {
			Piki.lockScroll()
		}

	}

	close() {
		this.target.classList.remove('opened')
		window.removeEventListener('click', this.handleOut)
		Piki.unlockScroll()
	}

}

window.addEventListener('DOMContentLoaded', () => {
	new Falecom()
});